<template>
    <div v-if="opened">
        <div class="fixed z:$(comment-overlay-zindex) w:full h:full bg:#0000001A top:0 left:0"></div>
        <div class="fixed z:$(comment-zindex) w:full h:full flex jc:flex-end top:0 left:0 {pt:36}@<sm" @click="hide">
            <div class="w:full max-w:414 h:full flex flex-direction:column bg:white rel {max-w:none;rt:20}@<sm" @click.stop>
                <div class="flex ai:center jc:space-between p:24|24">
                    <span class="f:20 font:bold">
                        留言<span class="ml:4">({{ count }})</span>
                    </span>
                    <button class="inline-flex w:24 h:24 ai:center jc:center" @click="hide" type="button">
                        <span class="bg:url(image/icon_close_login.svg) w:20 h:20 inline-block"></span>
                    </button>
                </div>
                <div class="
                    p:20 flex gap:10
                    {p:4|8;r:8;f:14;lh:1.428;bg:#5E64721A;color:#5E6472;inline-block;white-space:nowrap}>button
                    {bg:primary;color:white}>button.active
                ">
                    <button :class="{ active: type === 'hot' }" @click="show('hot')" type="button">最熱門</button>
                    <button :class="{ active: type === 'new' }" @click="show('new')" type="button">最新的</button>
                    <button :class="{ active: type === 'like' }" @click="show('like')" type="button">最推的</button>
                    <button :class="{ active: type === 'dislike' }" @click="show('dislike')" type="button">最廢的</button>
                    <button :class="{ active: type === 'observe' }" @click="show('observe')" type="button">最卡的</button>
                </div>
                <div class="bb:1|solid|#EBEBEB"></div>
                <div class="rel flex:1 overflow-y:auto" id="comment-panel">
                    <div class="rel" :id="`comment-${item.id}`" :key="item.id" v-for="(item, idx) in list">
                        <div class="mx:24 bb:1|solid|#EBEBEB" v-if="idx"></div>
                        <div class="py:24 px:24 {bg:#EDF5FF}.active" :class="{ active: item.id === latest }">
                            <topic-comment-row
                                @chuser="(type) => openNicknamePicker(item, type)"
                                @delete="openDeleteModal(item)"
                                @inform="openInformModal(item)"
                                :item="item"
                                :part-id="part.id"
                                :readonly="!userInfo.id"
                                @reply="openInput(item)"
                                @toggle="toggleReply(item)"
                            ></topic-comment-row>
                        </div>
                        <template v-if="item.toggle && item.content && item.list.length">
                            <div class="pb:24">
                                <div :id="`comment-${sub.id}`" :key="sub.id" v-for="sub in item.list">
                                    <div class="px:24 {bg:#EDF5FF}.active" :class="{ active: sub.id === latest }">
                                        <div class="py:20 ml:8 pl:24">
                                            <topic-comment-row
                                                @chuser="(type) => openNicknamePicker(sub, type)"
                                                @delete="openDeleteModal(sub)"
                                                @inform="openInformModal(sub)"
                                                :item="sub"
                                                :parent="item"
                                                :part-id="part.id"
                                                :readonly="!userInfo.id"
                                                @reply="openInput(sub, item)"
                                            ></topic-comment-row>
                                        </div>
                                    </div>
                                </div>
                                <div class="color:#A9A9A9 px:24 f:14 ml:32 cursor:pointer" @click="more(item.list)" v-if="item.list.length < item.reply_count">
                                    載入更多留言...
                                </div>
                            </div>
                        </template>
                    </div>
                    <div class="color:#A9A9A9 pb:24 px:24 f:14 mt:0! {d:none}::after cursor:pointer" @click="more(list)" v-if="list?.length < count">
                        載入更多留言...
                    </div>
                </div>
                <div class="
                    flex ai:center p:24 gap:8
                    border-top:1|solid|#EBEBEB
                    {flex:col;ai:stretch;gap:12}.actived
                    {flex}.actived_.username>div:nth-child(2)
                    {max-h:300;overflow-y:auto}.actived>div:nth-child(2)
                    {flex}.actived_.buttons
                " :class="{ actived: focus }">
                    <topic-comment-field @cancel="closeInput" @chuser="openNicknamePicker()" fixed @focus="focus = true" ref="field" :to="replyTo" @update="create" v-if="userInfo.id"></topic-comment-field>
                    <div class="w:100%" v-else>
                        <div class="f:20 color:#333333 mb:20 text:center">
                            <span class="font-weight:700 color:#538BD4">登入 OPT歐趴糖</span>，一起加入討論
                        </div>
                        <div class="text:center">
                            <a
                                class="
                                    w:175 h:49 border:0 bg:url(image/index/bg_btn.svg) background-size:100%|100%
                                    inline-flex jc:center ai:center color:white box-shadow:0|9|12|0|#1877F24D r:100 f:18 font-weight:700 lh:25px letter-spacing:1
                                "
                                href="login"
                            >
                                <span>登入 / 註冊</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <comment-delete-modal @confirm="deleteComment" ref="deleteModal"></comment-delete-modal>
    <comment-report-modal api="app/topic/list-inform-category" ref="informModal" @submit="informComment"></comment-report-modal>
    <nickname-picker @change="changeNicknameType" ref="nicknamePickerModal"></nickname-picker>
</template>

<script setup>
    const global = useGlobal();
    const userInfo = useUserInfo();

    let target = null;

    const props = defineProps({
        collegeId: { type: Number },
        id: { required: true, type: Number },
        part: { required: true, type: Object }
    });

    const count = ref(0);
    const focus = ref(false);
    const latest = ref();
    const list = ref();
    const opened = ref(0);
    const replyTo = ref();
    const type = ref("hot");

    const deleteModal = ref();
    const field = ref();
    const informModal = ref();
    const nicknamePickerModal = ref();

    const changeNicknameType = (newType) => {
        if (target) {
            target.newType = newType;
        } else {
            userInfo.type = newType;
        }
    };

    const closeInput = () => {
        focus.value = false;
        replyTo.value = null;
        field.value?.init();
    };

    const create = (data) => {
        if (replyTo.value) {
            const parent = replyTo.value.parent || replyTo.value;

            if (parent.reply_count != parent.list?.length) {
                if (parent.list) {
                    more(parent.list, data);
                } else {
                    toggleReply(parent, data);
                }
                return;
            }
        }

        data.topic_id = props.id;

        if (replyTo.value) {
            data.parent_id = replyTo.value.parent_id || replyTo.value.id;
            data.target_id = replyTo.value.id;
        }

        api("api/topic/comment/create", data, { prevent: true }).done((res) => {
            if (res.success) {
                latest.value = res.data.id;

                if (replyTo.value) {
                    const parent = replyTo.value.parent || replyTo.value;

                    if (!parent.list) {
                        parent.list = [];
                    }

                    if (parent.reply_count === parent.list.length) {
                        parent.list.push(res.data);
                        parent.toggle = true;
                    }

                    parent.reply_count += 1;
                } else {
                    if (!list.value) {
                        list.value = [];
                    }

                    count.value += 1;
                    list.value.unshift(res.data);
                }

                closeInput();

                setTimeout(() => {
                    const panel = $("#comment-panel");
                    let offset = 0;

                    if (res.data.parent_id) {
                        const content = $(`#comment-${res.data.id}`);

                        if (!content.length) {
                            return;
                        }

                        const container = $(`#comment-${res.data.parent_id}`);

                        offset = container.parent().scrollTop() + container.position().top + content.position().top; //置頂
                        offset -= (panel.height() - content.height()) / 2; //置中
                    }

                    panel.animate({ scrollTop: offset }, 300);
                });
            } else if (res.type === "error") {
                if (res.error === "error.permission-denied") {
                    hide();
                    global.openCollegeValidator(props.collegeId);
                } else {
                    global.error(res.message || res.error);
                }
            }
        });
    };

    const deleteComment = () => {
        api("api/topic/comment/remove", { comment_id: target.id }).done((res) => {
            if (res.success) {
                target.content = null;
                global.error("留言已刪除");
            }
        });
    };

    const hide = () => {
        opened.value = 0;
        document.body.classList.remove("overflow:hidden");
    };

    const informComment = (data) => {
        api("api/topic/inform", {
            topic_id: target.topic_id,
            comment_id: target.id,
            category_id: data.reason_id,
            content: data.content
        }).done((res) => {
            if (res.success) {
                global.success("已成功送出");
                informModal.value.hide();
            }
        });
    };

    const more = (list, reply) => {
        const last = list[list.length - 1];

        const data = {
            type: type.value,
            after: last.id,
        };

        if (last.parent_id) {
            data.parent_id = last.parent_id;
        } else {
            data.topic_id = last.topic_id;
        }

        api("api/topic/comment/list", data).done((res) => {
            if (res.success) {
                res.data.forEach((item) => {
                    list.push(item);
                });

                if (reply) {
                    create(reply);
                }
            }
        });
    };

    const open = () => {
        opened.value = 1;
        document.body.classList.add("overflow:hidden");
        nextTick(() => field.value?.focus());
    };

    const openDeleteModal = (item) => {
        target = item;
        deleteModal.value.show();
    };

    const openInformModal = (item) => {
        target = item;
        informModal.value.show();
    };

    const openInput = (item, parent) => {
        item.parent = parent;
        replyTo.value = item;
        field.value?.focus();
    };

    const openNicknamePicker = (item, type) => {
        target = item;
        nicknamePickerModal.value.show(type, props.part);
    };

    const show = async (newType) => {
        if (newType) {
            if (newType !== type.value) {
                type.value = newType;

                api("api/topic/comment/list", { type: type.value, topic_id: props.id }).done((res) => {
                    if (res.success) {
                        count.value = res.count;
                        list.value = res.data;
                    }
                });
            }
        } else if (list.value) {
            open();
        } else {
            api("api/topic/comment/list", { type: type.value, topic_id: props.id }).done((res) => {
                if (res.success) {
                    count.value = res.count;
                    list.value = res.data;
                    open();
                }
            });
        }
    };

    const toggleReply = (item, reply) => {
        if (item.list) {
            item.toggle = !item.toggle;
        } else {
            api("api/topic/comment/list", { type: type.value, parent_id: item.id }).done((res) => {
                if (res.success) {
                    item.reply_count = res.count;
                    item.list = res.data;
                    item.toggle = !item.toggle;

                    if (reply) {
                        create(reply);
                    }
                }
            });
        }
    };

    defineExpose({ show });

    userInfo.init();

    watch(count, (value) => {
        if (value) {
            $(`[data-comment-count=${props.id}]`).text(value);
        }
    });

    watch(() => props.id, () => {
        count.value = 0;
        focus.value = false;
        latest.value = null;
        list.value = null;
        opened.value = 0;
        replyTo.value = null;
        type.value = "hot";
    });
</script>
